import { useEffect, useState } from "react"
import { api } from "../../../api/api"
import { DateTime } from "luxon"
import { maskCurrency, numOrderFormat } from "../../../utils/utils"
import { LIST_STATUS } from "../../../utils/constantes"
import { useCompany } from "../../../hooks/useCompany"
import { FiCalendar, FiDollarSign, FiPackage, FiSearch, FiTruck, FiX } from "react-icons/fi"
import "./style.css"

export function OrdersWithMotoboyModal({ id, set }) {
  const [orders, setOrders] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { configurations } = useCompany()

  const [dates, setDates] = useState({
    startDate: DateTime.utc().startOf('month').toSQLDate(),
    endDate: DateTime.utc().endOf('month').toSQLDate()
  })

  async function findOrders(idMotoboy, startDate, endDate) {
    let url = `/orders/reporting/${idMotoboy}/orders`

    if (startDate && endDate) {
      url += `?startDate=${DateTime.fromSQL(startDate).toSQL()}&endDate=${DateTime.fromSQL(endDate).toSQL()}`
    }

    setIsLoading(true)

    try {
      const response = await api.get(url)
      setOrders(response.data)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (id)
      findOrders(id, dates.startDate, dates.endDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const { calculatePricingCostFrete, calculatePricingFretePaymentWithCustomer } = orders
    .reduce((prev, current) => {
      const aux = current?.deliveryDistrict

      if (!aux) {
        return prev
      }

      if (aux?.free) {
        return {
          ...prev,
          calculatePricingCostFrete: prev.calculatePricingCostFrete + (aux.pricing ?? 0)
        }
      }

      return {
        ...prev,
        calculatePricingFretePaymentWithCustomer: prev.calculatePricingFretePaymentWithCustomer + (aux.pricing ?? 0)
      }
    }, {
      calculatePricingCostFrete: 0,
      calculatePricingFretePaymentWithCustomer: 0
    })
  const fixedDeliveryCost = orders.length * (+configurations.pricingDefaultDeliveryMotoboy || 0)

  return (
    <div className="modal fade motoboy-orders-modal" id="modal-orders-motoboy" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="modal-orders-motoboyLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header motoboy-orders-header">
            <div className="motoboy-orders-heading">
              <span><FiTruck /></span>
              <div><h5 className="modal-title" id="modal-orders-motoboyLabel">Pedidos entregues</h5><p>Consulte as entregas e os custos do período selecionado.</p></div>
            </div>
            <button type="button" className="motoboy-orders-close" data-bs-dismiss="modal" aria-label="Fechar" onClick={() => set(null)}><FiX /></button>
          </div>
          <div className="modal-body">
            <div className="motoboy-orders-filters">
              <label><span>Data inicial</span><div><FiCalendar /><input type="date" value={dates.startDate} onChange={(e) => setDates({ ...dates, startDate: e.target.value })} /></div></label>
              <label><span>Data final</span><div><FiCalendar /><input type="date" value={dates.endDate} onChange={(e) => setDates({ ...dates, endDate: e.target.value })} /></div></label>
              <button type="button" onClick={() => findOrders(id, dates.startDate, dates.endDate)} disabled={isLoading}><FiSearch /> {isLoading ? 'Pesquisando...' : 'Pesquisar'}</button>
            </div>

            <div className="motoboy-orders-table-wrap">
              <table className="motoboy-orders-table">
                <thead>
                  <tr>
                    <th>Nº pedido</th>
                    <th>Cliente</th>
                    <th>Status</th>
                    <th>Preço da entrega</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => {
                    return (
                      <tr key={order.id}>
                        <td><strong>{numOrderFormat(order?.numOrder)}</strong></td>
                        <td>{order.name || 'Cliente não informado'}</td>
                        <td><span className="motoboy-order-status">{LIST_STATUS.find(e => e.status === order.status)?.name || order.status}</span></td>
                        <td>
                          {(order?.deliveryDistrict?.free ?? null) && 'Grátis'}
                          {!(order?.deliveryDistrict?.free ?? null) && maskCurrency(order?.deliveryDistrict?.pricing ?? 0)}
                        </td>
                        <td>{DateTime.fromISO(order.createdAt).toLocal().toFormat("dd/MM/yyyy HH:mm")}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>

              {!isLoading && orders.length === 0 && <div className="motoboy-orders-empty"><FiPackage /><strong>Nenhum pedido encontrado</strong><span>Tente selecionar outro período para consultar as entregas.</span></div>}
              {isLoading && <div className="motoboy-orders-empty"><FiSearch /><strong>Buscando pedidos...</strong></div>}
            </div>

            <div className="motoboy-orders-summary">
              <article><span><FiDollarSign /></span><div><small>Frete pago pelo cliente</small><strong>{maskCurrency(calculatePricingFretePaymentWithCustomer)}</strong></div></article>
              <article><span><FiTruck /></span><div><small>Custo real de frete</small><strong>{maskCurrency(calculatePricingCostFrete)}</strong></div></article>
              <article><span><FiPackage /></span><div><small>Custo fixo do entregador</small><strong>{maskCurrency(fixedDeliveryCost)}</strong><em>Baseado no valor fixo configurado</em></div></article>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
